import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../supabaseClient";

import "../styles/indeks.css";

export default function Indeks() {
  const [kategorije, setKategorije] = useState([]);
  const [filter, setFilter] = useState("slatko"); // default prikaz

  useEffect(() => {
    async function load() {
      try {
        const { data, error } = await supabase
          .from("categories") // 🔥 tvoje Supabase ime tablice
          .select("*")
          .order("name", { ascending: true });

        if (error) throw error;

        setKategorije(
          data.map((k) => ({
            id: k.id,
            name: k.name,
            slug: k.slug,
            type: k.type, // slatko / slano
            description: k.description,
          }))
        );
      } catch (err) {
        console.error("❌ Greška kod učitavanja kategorija:", err);
      }
    }

    load();
  }, []);

  // Filtriranje kategorija po tipu (slatko / slano)
  let filtered = kategorije.filter((k) => k.type === filter);
  
  if (filter === "slatko") {
    // Izbaci kategoriju "kolači" (prazna je)
    filtered = filtered.filter((k) => {
      const nameLower = k.name.toLowerCase();
      const slugLower = k.slug.toLowerCase();
      return !(nameLower.includes("kolači") || nameLower.includes("kolaci") || 
               slugLower.includes("kolači") || slugLower.includes("kolaci"));
    });
    
    // Sortiraj tako da "ostalo" bude na dno
    filtered.sort((a, b) => {
      const aName = a.name.toLowerCase();
      const bName = b.name.toLowerCase();
      const aSlug = a.slug.toLowerCase();
      const bSlug = b.slug.toLowerCase();
      
      const aIsOstalo = aName.includes("ostalo") || aSlug.includes("ostalo");
      const bIsOstalo = bName.includes("ostalo") || bSlug.includes("ostalo");
      
      if (aIsOstalo && !bIsOstalo) return 1; // a ide na dno
      if (!aIsOstalo && bIsOstalo) return -1; // b ide na dno
      return a.name.localeCompare(b.name); // ostale sortiraj abecedno
    });
  } else if (filter === "slano") {
    // Izbaci kategoriju "kruh" (ali ne "kruh i peciva") i "pizza" (prebačena u "ostalo")
    filtered = filtered.filter((k) => {
      const nameLower = k.name.toLowerCase();
      const slugLower = k.slug.toLowerCase();
      
      // Sakrij "kruh" samo ako nije "kruh i peciva"
      const isKruh = (nameLower === "kruh" || slugLower === "kruh") && 
                     !nameLower.includes("peciva") && !slugLower.includes("peciva");
      
      return !(
        isKruh ||
        (nameLower.includes("pizza") || slugLower.includes("pizza"))
      );
    });
    
    // Sortiraj: "juhe" iznad "ostalo", "ostalo" na dno
    // Koristi prioritet: ostalo=3 (dno), juhe=2 (iznad ostalo), ostale=1 (abecedno)
    filtered.sort((a, b) => {
      const aName = a.name.toLowerCase();
      const bName = b.name.toLowerCase();
      const aSlug = a.slug.toLowerCase();
      const bSlug = b.slug.toLowerCase();
      
      const aIsOstalo = aName.includes("ostalo") || aSlug.includes("ostalo");
      const bIsOstalo = bName.includes("ostalo") || bSlug.includes("ostalo");
      const aIsJuhe = aName.includes("juhe") || aSlug.includes("juhe");
      const bIsJuhe = bName.includes("juhe") || bSlug.includes("juhe");
      
      // Odredi prioritet za svaku kategoriju
      const aPriority = aIsOstalo ? 3 : (aIsJuhe ? 2 : 1);
      const bPriority = bIsOstalo ? 3 : (bIsJuhe ? 2 : 1);
      
      // Sortiraj po prioritetu (veći prioritet = niže u listi)
      if (aPriority !== bPriority) {
        return aPriority - bPriority;
      }
      
      // Ako su istog prioriteta, sortiraj abecedno
      return a.name.localeCompare(b.name);
    });
  }

  return (
    <div className="indeks-page">
      <h1>Indeks recepata</h1>

      <p className="indeks-subtitle">
        Odaberi vrstu → zatim kategoriju → i otkrij sve recepte.
      </p>

      {/* Gumbi za odabir tipa */}
      <div className="toggle-group">
        <button
          className={`toggle-btn ${filter === "slatko" ? "active" : ""}`}
          onClick={() => setFilter("slatko")}
        >
          Slatko
        </button>

        <button
          className={`toggle-btn ${filter === "slano" ? "active" : ""}`}
          onClick={() => setFilter("slano")}
        >
          Slano
        </button>
      </div>

      {/* Lista kategorija */}
      <div className="category-list" key={filter}>
        {filtered.map((k) => (
          <Link
            to={`/recipes?category=${k.slug}&type=${filter}`}
            key={`${k.id}-${filter}`}
            className="category-item"
          >
            <h3>{k.name}</h3>
          </Link>
        ))}
      </div>
    </div>
  );
}
